import { Component } from '@angular/core';

@Component({
  selector: 'lib-page-header',
  imports: [],
  templateUrl: './page-header.html',
  styleUrl: './page-header.css',
})
export class PageHeader {

}
